import axios from 'axios'

export default async function ({ route, store, $config }) {
  var pathArr = route.path.split('/')
  var path = pathArr[1]
  if (path && path !== '~' && path !== '__webpack_hmr') {
    store.dispatch('setShopId', path)
    const systemLocale = store.state.locale
    if (store.state.user) {
      await store.dispatch('userdata')
    }
    const userLocale = store.state.locale 
    if (systemLocale !== userLocale) {
      await store.dispatch('setUserLocale', userLocale)
    }
    var locale = store.state.locale ? store.state.locale : 'fi_FI'
    if (!store.state.settings[path + '-' + locale]) {
      let pubStr = '/public.json?'
      if (store.state.apiKey) {
        pubStr = '.json?apikey=' + store.state.apiKey + '&'
      }
      return axios.all([
        axios.get($config.baseDomain + path + '/' + locale + '/settings' + pubStr + 'version=' + locale + '&pricetiers=true&files=true&alltags=true' + (store.state.apiKey ? '&deliverymethods=true' : ''))
        .catch(() => {
          console.log(path, 'Settings not found')
          store.dispatch('setSettings', {
            shopId: path,
            locale: locale,
            settings: {}
          })
        }),
        axios.get($config.baseDomain + path + '/' + locale + '/linkedstores/public.json?version=' + locale)
        .catch(() => {
          console.log(path, 'Linked store not found')
          store.dispatch('setLinkedStores', {
            linkedStores: []
          })
        }),
        axios.get($config.baseDomain + path + '/' + locale + '/vouchers.json?iSortingCols=1&iSortDir_0=2')
        .catch(() => {
          console.log(path, 'Vouchers not found')
          store.dispatch('setVouchers', {
            vouchers: []
          })
        }),
      ])
      .then(axios.spread(async function (settings, linkedStores, vouchers) {
        store.dispatch('setSettings', {
          shopId: path,
          locale: locale,
          settings: settings.data
        })
        store.dispatch('setLinkedStores', {
          linkedStores: linkedStores.data
        })
        store.dispatch('setVouchers', {
          vouchers: vouchers.data
        })
        if (linkedStores && linkedStores.data && linkedStores.data.length && store.state.apiKey) {
          const results = await Promise.allSettled(linkedStores.data.map(ls => axios.get($config.serviceDomain + ls.shopid + '/' + locale + '/settings/public.json?version=' + locale + '&pricetiers=true' + (store.state.clientid ? '&deliverymethods=true&client=' + store.state.clientid + '&shop=' + path : ''))))
          for (let i = 0; i < results.length; i++) {
            const result = results[i]
            const linkedStoreShopId = linkedStores.data[i].shopid
            if (result.value && result.value.data) {
              store.dispatch('setSettings', {
                shopId: linkedStoreShopId,
                locale: locale,
                settings: result.value.data
              })
            } else {
              // Do nothing if we get an error
            }
          }
        }
      }))
      .catch((e) => {
        console.log(path, 'Error loading settings.', e)
        store.dispatch('setSettings', {
          shopId: path,
          locale: locale,
          settings: {}
        })
      })
    }
  }
}
